var Cookies = {
	init: function () {
		var allCookies = document.cookie.split('; ');
		for (var i=0;i<allCookies.length;i++) {
			var cookiePair = allCookies[i].split('=');
			this[cookiePair[0]] = cookiePair[1];
		}
	},
	create: function (name,value,days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			var expires = "; expires="+date.toGMTString();
		}
		else var expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
		this[name] = value;
	},
	erase: function (name) {
		this.create(name,'',-1);
		this[name] = undefined;
	}
};
Cookies.init();

var activeZbozi = unescape(Cookies['actZbozi']);
if (activeZbozi == "null") { activeZbozi = ""; }
var today = new Date();
var expire = new Date();

function ulozDoCookies(id_zbozi, pocet_ks) 
{
	var selItems = activeZbozi.split("*");
	var itemExists = false;
	for (var i in selItems) {
		var item = selItems[i];
		var itemDetail = item.split(":");
		if (itemDetail[0] == id_zbozi)
		{
			activeZbozi = activeZbozi.replace(item, "");
		}
	}

	if (pocet_ks > 0)
	{
		// pridame zbozi
		var newItem = id_zbozi.toString() + ":" + pocet_ks.toString();
		if (activeZbozi.length == 0)
		{
			activeZbozi = newItem;
		}
		else
		{
			activeZbozi += "*" + newItem;
		}
	}

	activeZbozi = activeZbozi.replace("**", "*");

	var inpHidden = document.getElementById('seznamZbozi');
	if (inpHidden != null)
	{
		inpHidden.value = activeZbozi;
	}

	Cookies.create('actZbozi',escape(activeZbozi),7);

}

function odeberZCookies(id_zbozi) 
{
	var selItems = activeZbozi.split("*");
	var itemExists = false;
	for (var i in selItems) {
		var item = selItems[i];
		var itemDetail = item.split(":");
		if (itemDetail[0] == id_zbozi)
		{
			activeZbozi = activeZbozi.replace(item, "");
		}
	}

	var inpHidden = document.getElementById('seznamZbozi');
	if (inpHidden != null)
	{
		inpHidden.value = activeZbozi;
	}
	
	Cookies.create('actZbozi',escape(activeZbozi),7);
}

function oznacDriveVybrane() 
{
	var selItems = activeZbozi.split("*");
	var itemExists = false;
	for (var i in selItems) {
		var item = selItems[i];
		var itemDetail = item.split(":");
		var inpElem = document.getElementById('zboziId' + itemDetail[0]);
		if (inpElem != null)
		{
			inpElem.value = itemDetail[1];
			document.getElementById('zboziSeznamId' + itemDetail[0]).checked = true;
		}
	}

	var inpHidden = document.getElementById('seznamZbozi');
	if (inpHidden != null)
	{
		inpHidden.value = activeZbozi;
	}
}

function odznacitVse() 
{
	expire.setTime(today.getTime() + 3600000*24*-1);
	document.cookie = "actZbozi"+"=;expires="+expire.toGMTString();
}

function markAll(typ) 
{
	var loop = 1;
	var zboziElem = document.getElementById('zboziSeznamId'+loop);
	while (zboziElem != undefined) {
		if (typ == 0) 
		{
			zboziElem.checked = false;
			document.getElementById('zboziId'+loop).value = '';
		} else {
			zboziElem.checked = true;
		}
		loop++;
		zboziElem = document.getElementById('zboziSeznamId'+loop);
	}
}

function oznacZbozi(elem, id_zbozi) 
{
	if (elem.value.length == 0) {
		document.getElementById('zboziSeznamId'+id_zbozi).checked = false;
		odeberZCookies(id_zbozi);
	} else {
		document.getElementById('zboziSeznamId'+id_zbozi).checked = true;
		ulozDoCookies(id_zbozi, elem.value);
	}
}

function zpracujZbozi(elem) 
{
	// odebirame nebo pridavame zbozi
	var id_zbozi = elem.id.replace('zboziSeznamId', '');
	if (elem.checked)
	{
		var inpElem = document.getElementById('zboziId'+id_zbozi);
		ulozDoCookies(id_zbozi, inpElem.value);
	}
	else
	{
		var inpElem = document.getElementById('zboziId'+id_zbozi);
		inpElem.value = '';
		odeberZCookies(id_zbozi);
	}
}

function checkZboziForm(myForm, msg) 
{
	if (activeItems.length == 0) 
	{
		alert(msg);
		return false;
	} else {
		return true;
	}
}

function odeslatKeKontrole() {
	window.location.href = '/uniformy;seznamZbozi=' + document.getElementById('seznamZbozi').value.replace('undefined*', '');
}

function kontrolaDodaciAdresyForm(msg) {
	if ($('#daNazev').val() == '' || $('#daUlice').val() == '' || $('#daMesto').val() == '' || $('#daPsc').val() == '') {
		alert(msg);
		return false;
	}

	var psc = $('#daPsc').val();
	if (!psc.match(/^[0-9]{4,6}$/)) {
		alert(msg);
		return false;
	}

	return true;
}
